<template>
  <section>


<div class="navPrincipal" >
 
</div>

    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <v-toolbar flat dark color="accent">
          <v-flex xs12 offset-xs1 >
            <v-card-title class="white--text pt-2 pb-0 title">Cursos vigentes</v-card-title>
          </v-flex>
        </v-toolbar>
        <div align="center" class="mt-5" v-if="cursos.length==0">
                          <!-- <v-alert
                              :value="true"
                              type="success"
                            >
                              No existen Evaluaciones diseñadas para este curso.
                            </v-alert> -->
                            <i style="font-size: 8em; color:#E0E0E0;"  class="material-icons">
                      error
                      </i>
                      <p>No existen Cursos Vigentes.</p>
                        </div>  
        <div v-else>
        <v-layout row v-for="item in cursos" :key="item.id">
        <v-flex xs4 >
          
          <router-link :to="{ name: 'showCourcesOption', params: { id: item.id }}"  class="enlace">
          <v-card class="my-2 mx-2">
            <h3 class="primary--text px-2" > {{ item.cource_title }} </h3>
            
            <p class="px-2 grey--text">{{ item.cource_description }} </p>
            <v-toolbar dark color="secondary" height="10">
              <v-toolbar class="mr-0 ml-5" dark color="white"  height="1"></v-toolbar>
            </v-toolbar>
            </v-card>
          </router-link>
          
          
        </v-flex>
        </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import { getAllCurseOfUserService } from '@/services/GetAllCurseOfUser.service'
export default {
  data () {
    return {
      cursos: []
    }
  },
  mounted () {
    let vm = this
    vm.loadCursos()
  },
  methods: {
    loadCursos () {
      let vm = this
      getAllCurseOfUserService.query().then(data => {
        vm.cursos = data.body
      })
    },
    verCurso (id) {
      this.$router.push({name: 'ListCourses', params: {id: id}})
    }
  }
}
</script>

<style scoped>
 .enlace {
  text-decoration:none;
}

.navPrincipal{
  background-image: url('../../../static/imagenPrincipal1280.png'); 
  background-repeat: no-repeat;
  background-size: 100% 100%; height: 200px
}
</style>


// WEBPACK FOOTER //
// src/components/Calificacion/ListCourse.vue